export default __webpack_public_path__ + "static/media/calibri-regular.82e3b164.ttf";